import store from '@/store';

class NumberService {
   public static precise_round(num, decimals) {
      return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
   }

   public static formatNumbers(number, currencyFraction) {
      const res = parseFloat(number ?? 0).toLocaleString('en-US', {
         minimumFractionDigits: currencyFraction,
         maximumFractionDigits: currencyFraction,
      });
      return res;
   }

   static parseFloat(strNumber) {
      return parseFloat(String(strNumber).replaceAll(',', ''));
   }

   public static formatNumbersByCompany(number) {
      const currencyFraction = parseInt(
         store.state['CompanyModule'].companySetting.currency_fractions,
      );

      return parseFloat(number ?? 0).toLocaleString('en-US', {
         minimumFractionDigits: currencyFraction,
         maximumFractionDigits: currencyFraction,
      });
   }
}

export default NumberService;
